<div class="modal-header"  *ngIf="orders" >
    <h4 class="modal-title">Purchase Orders</h4>
</div>
<div class="modal-body"  *ngIf="orders"  (keyup.esc)="close()">
    <dx-data-grid #dataGrid [dataSource]="orders" height="300px" keyExpr="id" [columnAutoWidth]="false" (onCellDblClick)="rowDoubleClick($event)">
        <dxi-column dataField="purchaseOrder.pONumber" caption="PO #" width="80"></dxi-column>
        <dxi-column dataField="purchaseOrder.vendor.companyName" caption="Vendor" width="250"></dxi-column>
        <dxi-column dataField="quantity" width="100"></dxi-column>
        <dxi-column dataField="quantityReceived" caption="Received" width="100"></dxi-column>
        <dxi-column dataField="quantityBackOrdered" caption="BackOrdered" width="100"></dxi-column>
        <dxi-column dataField="purchaseOrder.createDate" caption="Date" width="100"></dxi-column>
        <dxi-column dataField="purchaseOrder.status.name" caption="Status" width="100"></dxi-column>

        <dxo-selection [mode]="'single'"></dxo-selection>
    </dx-data-grid>
</div>
<div class="modal-footer" *ngIf="orders" >
    <button type="button" class="btn btn-primary" (click)="select()">Select</button>
    <button type="button" class="btn btn-light" (click)="close()">Cancel</button>
</div>
